<script lang="ts">
    import { createEventDispatcher } from 'svelte';

    import Modal from './Modal.svelte';

    export let confirmationIsVisible: boolean;
    let error;
    const dispatch = createEventDispatcher();
</script>

<Modal
    on:close={() => {
        confirmationIsVisible = false;
    }}
>
    <h2 class="text-lg-fluid">Ist die Transkription vollständig?</h2>

    <ul class="border-t divide-y mt-5 mb-10">
        <li class="py-6">Alle Seiten des Briefes wurden transkribiert.</li>
        <li class="py-6">Alle für Sie lesbaren Wörter wurden transkribiert.</li>
        <li class="py-6">Nicht lesbare Wörter wurden mit […] markiert.</li>
    </ul>

    {#if error}
        <p class="text-sm-fluid text-orange mb-3" aria-live="assertive">{error}</p>
    {/if}

    <div slot="bottom" class="flex space-x-5">
        <button
            class="button"
            type="button"
            on:click={() => {
                dispatch('completed');
            }}>Ja, vollständig</button
        >
        <button
            class="button"
            type="button"
            on:click={() => {
                dispatch('incomplete');
            }}>Nein, unvollständig</button
        >
    </div>
</Modal>
